import { render, staticRenderFns } from "./Powerbox.vue?vue&type=template&id=e0edf2ba&scoped=true"
import script from "./Powerbox.vue?vue&type=script&lang=js"
export * from "./Powerbox.vue?vue&type=script&lang=js"
import style0 from "./Powerbox.vue?vue&type=style&index=0&id=e0edf2ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0edf2ba",
  null
  
)

export default component.exports